import React, { useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment';
import * as Yup from 'yup'
import { APIURL } from '../../../hoc/AxiosSetting/axios'
import axios from 'axios'

function Stage2AuditObservation() {
    const history = useHistory();
    const { orgcode } = useParams()

    const [initialValues, setInitialValues] = useState({
        _id: "",
        orgCode: 0,
        address:"",
        siteofaddress:'NA',
        effectiveNoEmpToBeAudited: "",
        mobile: "",
        email: "",
        scope: "",
        nabcbcodeName: "",
        contactPersonName:"",
        dateofaudit: "",
        auditteam: "",
        purpose: "",
        businesssector: "",
        teamleaderName: "",
        accompanyingteam: "",
        purspose: "",
        significantchanges:"",
        technicalexpertName:"",
        datestage2observation:"",
        placeofaudit:"",
        anydeviationinauditplan:"",
        briefaboutorg:"",
        anysignificantissue:"",
        anyunresolved:"",
        criteriaofaudit: "",
        objectiveofaudit: "",
        verificationofeffectiveness : "",
        externalissues: "",
        internalissues: "",
        needsandexpectations: "",
        riskandopportunity: "",
        gpPvtHealthSubCenterOptions:"Yes",
        typeofaudit:"Initial Audit",
        
    })

 

    const gpPvtHealthSubCenterOptions = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
    ]

    const typeofaudit = [
        { key: 'Initial Audit ', value: 'Initial Audit' },
        { key: 'Special Audit', value: 'Special Audit' }
    ]



      const validationSchema =Yup.object({
        anydeviationinauditplan:Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        briefaboutorg:Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        criteriaofaudit:Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        objectiveofaudit:Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        externalissues: Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        internalissues: Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        needsandexpectations: Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        riskandopportunity: Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        placeofaudit: Yup.string().required('Required'),
        datestage2observation: Yup.string().required('Required')

      })
       

    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + params, {}), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                tempInitialValues.orgCode= data.data.response.orgCode
                tempInitialValues.address = data.data.response.address || "";
                tempInitialValues.effectiveNoEmpToBeAudited = data.data.response.effectiveNoEmpToBeAudited || "";
                tempInitialValues.email = data.data.response.email || "";
                tempInitialValues.contactPersonName = data.data.response.contactPersonName || "";
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit)|| null;
                tempInitialValues.datestage2observation = Date.parse(data.data.response.datestage2observation)|| null;
                tempInitialValues.auditteam = data.data.response.auditteam || "";
                tempInitialValues.mobile = data.data.response.mobile || "";
                tempInitialValues.placeofaudit = data.data.response.placeofaudit || "";
                tempInitialValues.significantchanges = data.data.response.significantchanges || "";
                tempInitialValues.positivefindings = data.data.response.positivefindings || "";
                tempInitialValues.nabcbcodeName = data.data.response.nabcbcodeName || "";
                tempInitialValues.typeofaudit = data.data.response.typeofaudit || "Initial Audit";
                tempInitialValues.siteofaddress = data.data.response.siteofaddress || "NA";
                tempInitialValues.gpPvtHealthSubCenterOptions = data.data.response.gpPvtHealthSubCenterOptions || "Yes"
                // 
                
                // tempInitialValues.scopeofcertification = data.data.response.scope || "";
                setInitialValues(tempInitialValues)
            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })

    const { data: OrgList, isLoading: orgLoading } = useQuery(
        'listorg',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesauditplandata/'+localStorage.getItem("userCode"), {}))
        
      
        const mutation = useMutation((params) => Fetcher('patch', '/api/stagetwo/patch/auditobservation', params), {
            onSuccess(data) {
                if (data.data.errorCode === 0) {
                    ToastInstance('Success', 'Audit Observation Data Added')
                    //  history.push('/admin/view/stage2auditobservationsheet/' + data.data.response.orgCode);
                    window.location.href="/"+localStorage.getItem("role")+'/view/stage2auditobservationsheet/' + data.data.response.orgCode
                } else {
                    var msg = 'Audit Report - ' + data.data.errorMsg;
                    ToastInstance('Error', msg)
                }
            },
            onError(error) {
                console.log('Got error from backend', error)
                ToastInstance('Error', 'Subject' + error)
            }
        })
        const onSubmit = (values, { setSubmitting, resetForm }) => {
            mutation.mutate(values)
        }
        // const { data: stage2data, isLoading} = useQuery(
        //     'liststage2',
        //     () => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + orgcode, {}))
        
            const { data: auditorList, isLoading: auditorListLoading } = useQuery(
                'listauditor',
                () => Fetcher('get', '/api/auditormaster/get/valuelabelforauditor', {}))
        
    
        // useEffect(() => {
        //     if (stage2data && initialValues.orgCode === 0 ) {
        //         var tempData = stage2data.data.response
        //         tempData.dateofaudit = Date.parse(tempData.dateofaudit)
        //         tempData.datestage2observation = Date.parse(tempData.datestage2observation)
        //       //  tempData.internalauditDes = Date.parse(tempData.internalauditDes)
        //         setInitialValues(tempData)
    
        //     }
        // }, [orgcode && !isLoading && initialValues.orgCode === 0])

        const getUrl = () =>{
            const api= APIURL + '/api/stagetwo/get/stagetwodata/' + orgcode
            axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
            .then(stage2data=>{
                if (stage2data && initialValues.orgCode === 0) {
                    var tempData = stage2data.data.response
                    tempData.dateofaudit = Date.parse(tempData.dateofaudit)
                    tempData.datestage2observation = Date.parse(tempData.datestage2observation)
                  //  tempData.internalauditDes = Date.parse(tempData.internalauditDes)
                    setInitialValues(tempData)

            }
    
                
               
            })
            .catch(err=>{
                var string= JSON.stringify(err).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);
                
                console.log("found",found);
                if(found !== null){
                    console.log(err)
                    window.location.href = "/signin"
                }
    
            })
        }
       
        useEffect(() => {
            if(orgcode!== undefined){
                getUrl()
            }
           
        }, [orgcode!== undefined])

    if (orgLoading || auditorListLoading) return <h1>Loading</h1>
    if (orgcode && initialValues.orgCode === 0){
       
        // window.location.href = "/signin"
          return <h1>Loading Data</h1>
         
       }
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {
                    formik => <Form>
                        <div className="content-wrapper">
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <form>
                                                        <div className="formOuterDiv">
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='selectNACECode' name='orgCode' options={OrgList.data.response} onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} label='Organization'/>                                        
                                                            </div>
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='input' type="text" name='address' label='Address' className="form-control" disabled={true}/>                                        
                                                            </div>

                                                            <div className="form2RowDiv"> 
                                                                    <FormikControl  control='input' type="text" name='siteofaddress'  label='Site Address (If any)' disabled={true}/>
                                                                    <FormikControl control='input' type="text" name='effectiveNoEmpToBeAudited' label='No. of Employees' disabled={true}/>
                                                                        
                                                            </div>
                                                            <div className="form2RowDiv"> 
                                                                    <FormikControl  control='input' type="text" name='email'  label='Email id' disabled={true}/>
                                                                    <FormikControl control='input' type="text" name='contactPersonName' label='Contact Person' disabled={true}/>
                                                                        
                                                            </div>
                                                            <div className="form2RowDiv"> 
                                                                    <FormikControl  control='input' type="text" name='mobile'  label='Mobile/Fax' disabled={true}/>
                                                                    <FormikControl control='input' type="text" name='nabcbcodeName' label='ANZSIC Code / NACE CODE' disabled={true}/>
                                                                        
                                                            </div>
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='textarea' type="text" name='scope' disabled={true} label='Scope' className="form-control" />                                        
                                                            </div>
                                                            <div className="row mt-3" style={{marginLeft:"0.5%"}}>
                                                                <div className="col-sm-7 text-dark">
                                                                    <label>Non applicable requirements as determined by organisation: </label>
                                                                </div>
                                                                <div className="col-sm-5">
                                                                    <p>All Clauses are applicable</p>
                                                                </div>
                                                                <div className="row mt-2">
                                                                    <div className="row">
                                                                        <label htmlFor="staticEmail" className="col-sm-6">Justification for Non applicability checked and accepted?</label>
                                                                        <div className="col-sm-6">
                                                                            <FormikControl control='radio' name='gpPvtHealthSubCenterOptions' options={gpPvtHealthSubCenterOptions} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mt-3">
                                                                    <div className="row">
                                                                        <label htmlFor="staticEmail" className="col-sm-6">Type Of Audit</label>
                                                                        <div className="col-sm-6">
                                                                            <FormikControl control='radio' name='typeofaudit' options={typeofaudit} />
                                                                        </div>
                                                                        
                                                                    </div>
                                                                    <p className="mt-4"><b>Note: </b><i>Combined/Joint/integrated audit(If Applicable) </i></p>
                                                                </div>
                                                            </div>
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='input' type="text" name='significantchanges' disabled={true} label='Significant Changes(if any),Since last audit that affects QMS'/>                                        
                                                            </div>
                                                            {/* <div className="form1RowDiv"> 
                                                                <FormikControl  control='input' type="text" name='auditteam'  label='Audit Team'/>                                        
                                                            </div> */}
                                                               <div className="hrstyle">
                                                            <h5>Audit Team</h5>
                                                        </div>

                                                    <div className="form2RowDiv">
                                                            {/* <FormikControl control="selectNACECode" name="teamleader" label="Team Leader/ Lead Auditor" options={auditorList.data.response}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`teamleader`, e.value)
                                                                    formik.setFieldValue(`teamleaderName`, e.label)
                                                                }}
                                                                disabled={true}/> */}
                                                        <FormikControl control='input' type='text' label='Team Leader/ Lead Auditor' name='teamleaderName' disabled={true}/>
                                                        <FormikControl control='input' type='text' label='Technical expert' name='technicalExpertName' disabled={true}/>

                                                    </div>

                                                            {/* <div className="form2RowDiv"> 
                                                                    <FormikControl  control='input' type="text" name='teamleaderName' label='Lead Auditor'/>
                                                                    <FormikControl control='input' type="text" name='technicalexpertName' label='Technical Expert'/>
                                                                        
                                                            </div> */}
                                                            <div className="form2RowDiv"> 
                                                                    <FormikControl  control='date' dateFormat="dd-MM-yyyy" name='datestage2observation' className="form-control" label='Audit Observation Date *'/>
                                                                    <FormikControl  control='input' type="text" name='placeofaudit' label='Place of the Audit *'/>
                                                                        
                                                            </div>
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='textarea' type="text" name='anydeviationinauditplan'  label='Any Deviation in the Audit Plan and Reason(if any) *'/>                                        
                                                            </div>
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='textarea' type="text" name='briefaboutorg'  label='Brief about the organization *'/>                                        
                                                            </div>
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='input' type="text" name='anysignificantissue'  label='Any Significant issue impacting on the Audit Programme *'/>                                        
                                                            </div>
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='input' type="text" name='anyunresolved'  label='Any unresolved issues(if identified) *'/>                                        
                                                            </div>

                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='textarea' type="text" name='criteriaofaudit'  label='Criteria of Audit(Disclaimer Statement) *'/>                                        
                                                            </div>
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='textarea' type="text" name='objectiveofaudit'  label='Objective of Audit *'/>                                        
                                                            </div>
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='textarea' type="text" name='verificationofeffectiveness'  label='Verification of effectiveness of NC closure of Stage 1 Audit(If any)*'/>                                        
                                                            </div>
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='textarea' type="text" name='externalissues'  label='External Issues*'/>                                        
                                                            </div>
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='textarea' type="text" name='internalissues'  label='Internal Issues*'/>                                        
                                                            </div>
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='textarea' type="text" name='needsandexpectations'  label='Needs and Expectations of interested parties *'/>                                        
                                                            </div>
                                                            <div className="form1RowDiv"> 
                                                                <FormikControl control='textarea' type="text" name='riskandopportunity' label='Risk & Opportunity & Change Control*'/>                                        
                                                            </div>
                                                           

                                                           
                                                        </div>
                                                      
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </section>
                           
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <button type="submit" className="btn btn-primary float-right">Submit</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Form>
                }
            </Formik>
        </div>
    )
}

export default Stage2AuditObservation